module.exports = __webpack_public_path__ + "media/images/prizes__sidebar--image-5dc6a8d5d39bd29954f120a204bbe950.png";